module.exports = __webpack_public_path__ + "2e8830fa02b714d30b1538e77e5d8b21.png";